package com.evoapps.evoshift.data.dto.hiring

import kotlinx.serialization.Serializable

/** SH-210: `interviews/{id}` as functions/hiringPipeline.js writes it. */
@Serializable
data class InterviewDto(
    val id: String = "",
    val workplaceId: String = "",
    val rosterId: String = "",
    val date: String = "",
    val start: String = "",
    val end: String = "",
    val durationMinutes: Int = 0,
    val postId: String? = null,
    val applicationId: String? = null,
    val candidateName: String? = null,
    val jobTitle: String = "",
    val location: String? = null,
    val onlineUrl: String? = null,
    val note: String? = null,
    val participantIds: List<String> = emptyList(),
    val paid: Boolean = false,
    val status: String = "SCHEDULED",
    val sequence: Int = 0,
    val createdAt: String = "",
    val createdBy: String? = null,
    val updatedAt: String = "",
    val updatedBy: String? = null
)
